// Shared message bubbles used by the hero animation and the interactive demo.

export function ChatBubble({ from, text }) {
  return (
    <div className={`msg-row ${from}`}>
      <div className={`bubble ${from}`}>
        {from === 'ai' && <div className="ai-tag">✦ OWLA</div>}
        {text}
      </div>
    </div>
  );
}

export function TypingBubble({ variant = 'plain' }) {
  return (
    <div className="msg-row them">
      <div className={`typing ${variant}`}>
        <span className="typing-dot" />
        <span className="typing-dot" />
        <span className="typing-dot" />
      </div>
    </div>
  );
}
